import { ChevronLeft } from '@material-ui/icons';
import { useNavigate } from 'react-router'
import { Button } from '@mui/material';


const BackButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(-1);
  };

  return (
    <Button
      onClick={handleClick} variant="outlined"><ChevronLeft /> Back </Button>
  );
};



export default BackButton